const development = {
  API_BASE_URL: 'http://localhost:8083/api',
};

const production = {
  API_BASE_URL: '/api',
};

const baseConfig = process.env.NODE_ENV === 'production' ? production : development;

const config = {
  ...baseConfig,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || baseConfig.API_BASE_URL,
};

export default config;
